import styled from "styled-components";
import { themeColor } from "ui/theme";

export const RescheduleCard = ({ newDate, newTime }) => (
  <RescheduleCardWrap>
    <Title>re-schedule request</Title>
    <ContentRow>
      <RowName>New Date: </RowName>
      <span>{newDate}</span>
    </ContentRow>
    <ContentRow>
      <RowName>New Time: </RowName>
      <span>{newTime}</span>
    </ContentRow>
  </RescheduleCardWrap>
);

const RescheduleCardWrap = styled.div`
  background-color: ${themeColor("blue")};
  border-radius: 8px;
  box-shadow: 2px 2px 15.5px 0px #0000001a;
  padding: 1rem 1.5rem;
  color: ${themeColor("white")};
  font-size: 14px;
`;

const Title = styled.h4`
  text-transform: uppercase;
  margin-bottom: 12px;
`;

const ContentRow = styled.div`
  display: flex;
  gap: 12px;
`;

const RowName = styled.span`
  font-weight: 600;
`;
